import Button from '@cashew/button';
import ConfirmModal from '@cashew/confirm-modal';
import Dropdown from '@cashew/dropdown';
import Input from '@cashew/input';
import { api, priceFormat } from '@cashew/utils';
// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useState } from 'react';

export default ({
  orderDetails,
  showConfirmModal,
  setShowConfirmModal,
  orderId,
  history,
  subscriptionRefundsNumber,
  totalPaidSubscritpon,
  setChange,
  portalName,
  t,
}: any) => {
  type Status = 'warning' | 'error' | 'info' | 'success' | 'none';
  const [showResult, setShowResult] = useState(false);
  const [resultStatus, setResultStatus] = useState<Status>('none');
  const [refundLoading, setRefundLoading] = useState(false);
  const [isDisable, setIsDisable] = useState<boolean>(false);
  const [selectedSubscriptionRefunds, setSelectedSubscriptionRefunds] =
    useState(1);
  const [showReundConfirmationModal, setShowRefundConfirmationModal] =
    useState(false);
  const [refundError, setRefundError] = useState<any>();

  const searchByData: any[] = [];
  const generateRefundsNumberObj = (limit: number) => {
    for (let i = 1; i <= limit; i += 1) {
      searchByData.push({ key: `${i}`, value: `${i}` });
    }
    return searchByData;
  };

  const resultTitle =
    resultStatus === 'error'
      ? 'We encountered an issue'
      : `Order ${resultStatus === 'success' ? 'was' : 'was not'} refunded`;

  const resultDescription =
    resultStatus === 'error' ? (
      <div className="resultDescriptionStatus">
        <>
          The order &nbsp;
          <span>
            <b>{orderDetails.id}</b>
          </span>
          &nbsp; was not refunded, please reach out to our support by email at
          <br />
          <a
            style={{ color: '#fed01d' }}
            href="mailto:merchantsupport@cashewpayments.com"
          >
            <span>
              <b>merchantsupport@cashewpayments.com</b>
            </span>
          </a>
          &nbsp; for assistance.
        </>
      </div>
    ) : (
      <>
        The order &nbsp;
        <span>
          <b>{orderDetails.id}</b>
        </span>
        &nbsp;
        {resultStatus === 'success' ? 'was successfully' : 'was not'}
        &nbsp;refunded.
      </>
    );

  const confirmForm = (
    <div>
      {refundLoading && (
        <img className="loading-img" src="/loading.png" alt="Loading..." />
      )}
      <form className={refundLoading ? 'opacity-0' : ''}>
        <div className="form-row">
          <Input
            name="shippingReference"
            placeholder="Refund amount"
            value={priceFormat({
              currency: orderDetails.currencyCode,
              amount:
                selectedSubscriptionRefunds * orderDetails?.totalAmount || 0,
            })}
            maxLength={20}
            readonly
          />

          <div className="form-row-divider" />
          <Input
            name="grossOrderAmount"
            placeholder="Gross order total"
            value={priceFormat({
              currency: orderDetails.currencyCode,
              amount: totalPaidSubscritpon * orderDetails.totalAmount || 0,
            })}
            readonly
          />
        </div>
        {subscriptionRefundsNumber > 1 && (
          <div className="form-column ">
            <p>
              Set the numbers of subscriptions to refund,starting from the
              latest:
            </p>

            <div className="input-hint">
              <Dropdown
                data={generateRefundsNumberObj(subscriptionRefundsNumber)}
                label=""
                selected={`${selectedSubscriptionRefunds}`}
                onSelect={setSelectedSubscriptionRefunds}
                className="payment-link-search-dropdown"
              />
            </div>
          </div>
        )}
      </form>
    </div>
  );
  const onRefund = () => {
    setRefundLoading(true);
    setIsDisable(true);
    setRefundError('');
    api
					.post({
						endpoint: 'refunds',
						params: {
							orderId,
							refundAmount: orderDetails.totalAmount,
							cashewCustomerId: orderDetails.cashewCustomerId,
							storeId: orderDetails.storeId,
							refundsNumber: +selectedSubscriptionRefunds,
						},
					})
					.then(() => {
						setResultStatus('success');
						setChange(true);
						setIsDisable(false);
					})
					.catch((resp) => {
						setIsDisable(false);
						api.errorHandler({
							resp,
							history,
							callback: () => {
								setResultStatus(
									resp?.response?.data?.errorCode === '400.005.017'
										? 'warning'
										: 'error',
								);
								if (resp?.response?.data?.errorCode) {
									setRefundError(resp.response.data.errorCode);
								}
							},
						});
					})
					.finally(() => {
						setShowResult(true);
						setRefundLoading(false);
					});
  };

  const confirmButtons = (
    <div style={{ display: 'flex' }}>
      <Button
        extraClass="secondary"
        onClick={() => {
          setResultStatus('warning');
          setShowResult(true);
          setSelectedSubscriptionRefunds(1);
        }}
      >
        Cancel
      </Button>
      <Button
        extraClass="order-details__confirm"
        onClick={() => {
          setShowRefundConfirmationModal(true);
          setShowConfirmModal(false);
        }}
        disabled={!orderDetails.totalAmount}
      >
        Confirm
      </Button>
    </div>
  );
  const RefundButtons = (
    <div style={{ display: 'flex' }}>
      <Button
        extraClass="btn-black secondary "
        onClick={() => {
          setResultStatus('warning');
          setShowResult(true);
          setSelectedSubscriptionRefunds(1);
        }}
      >
        Cancel
      </Button>

      <Button
        loading={refundLoading}
        extraClass="refund-subsciption-btn"
        onClick={onRefund}
        disabled={!orderDetails.totalAmount || isDisable}
      >
        Refund
      </Button>
    </div>
  );
  const resultButtons = (
    <div>
      <Button
        onClick={() => {
          setResultStatus('none');
          setShowResult(false);
          setShowConfirmModal(false);
          setShowRefundConfirmationModal(false);
        }}
      >
        Ok
      </Button>
    </div>
  );

  return (
    <>
      <ConfirmModal
        isVisible={showConfirmModal}
        onClose={() => {
          setShowConfirmModal(false);
        }}
        showCloseButton={false}
        confirmTitle={`Request a refund for the order ${orderDetails.id}`}
        confirmDescription="Please review and confirm below"
        confirmForm={confirmForm}
        confirmButtons={confirmButtons}
        resultTitle={resultTitle}
        resultDescriptionComponent={resultDescription}
        resultButtons={resultButtons}
        showResult={showResult}
        resultStatus={resultStatus}
      />
      <ConfirmModal
        isVisible={showReundConfirmationModal}
        onClose={() => {
          setShowConfirmModal(false);
        }}
        showCloseButton={false}
        confirmTitle="Confirm refund?"
        confirmDescription={`Are you sure you want to refund last ${selectedSubscriptionRefunds} ${selectedSubscriptionRefunds > 1 ? 'subscriptions' : 'subscription'} of this order ?`}
        confirmButtons={RefundButtons}
        resultTitle={
          ['400.005.017', '400.005.020', '400.005.021'].includes(refundError)
            ? t(`refunds.error.title.${refundError}`)
            : resultTitle
        }
        resultDescriptionComponent={
          ['400.005.017', '400.005.020', '400.005.021'].includes(
            refundError
          ) ? (
            <div style={{ marginTop: 16 }}>
              {t(`refunds.error.description.${refundError}`)}
            </div>
          ) : (
            resultDescription
          )
        }
        resultButtons={resultButtons}
        showResult={showResult}
        resultStatus={resultStatus}
      />
    </>
  );
};
